export const PUBLISHER_REQUEST = 'PUBLISHER_REQUEST';
export const PUBLISHER_SUCCESS = 'PUBLISHER_SUCCESS';
export const PUBLISHER_FAILURE = 'PUBLISHER_FAILURE';
